import { FC } from 'react'

import { useLocalization } from '../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { intlPrettyCurrency } from '../../../../lib/utils'

import { TotalPriceSection } from './styles'

type Props = {
  totalPrice: number
}

export const BagTotal: FC<Props> = ({ totalPrice }) => {
  const {
    magnolia: {
      account: { total },
    },
  } = useTranslation()
  const { locale, region } = useLocalization()
  return (
    <TotalPriceSection>
      {total}:{' '}
      {intlPrettyCurrency({
        cents: totalPrice,
        region,
        locale,
        explicitFormat: true,
      })}
    </TotalPriceSection>
  )
}
